export const updateUrlQuery = (
  name: string,
  value: string,
  hash?: string
): void => {
  const url = new URL(window.location.href)
  url.searchParams.set(name, value)

  // If hash is provided, set it
  if (hash) {
    url.hash = hash.startsWith('#') ? hash : `#${hash}`
  }

  window.history.replaceState({}, '', url.toString())
}
